import { render, staticRenderFns } from "./AbfActiveFilters.vue?vue&type=template&id=c04126c2&scoped=true&"
import script from "./AbfActiveFilters.vue?vue&type=script&lang=js&"
export * from "./AbfActiveFilters.vue?vue&type=script&lang=js&"
import style0 from "./AbfActiveFilters.vue?vue&type=style&index=0&id=c04126c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04126c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VIcon,VLayout,VSpacer})
